import React, { useEffect, useState } from 'react';
import SocialStream from '../Dashboard/SocialStream';
import ProductsPanel from '../Dashboard/ProductsPanel';
import MatchModal from '../Dashboard/MatchModal';
import { toast } from 'sonner';
import { generateMockPosts } from '../../utils/mockData';
const LiveFeed: React.FC = () => {
  const [posts, setPosts] = useState(generateMockPosts(10));
  const [products, setProducts] = useState([{
    id: 1,
    name: 'Animal Shelter Volunteering',
    description: 'Help animals find forever homes',
    image: 'https://images.unsplash.com/photo-1548199973-03cce0bbc87b',
    isMatching: false,
    intentPhrases: ['I want to help animals in need', 'Looking for pet adoption centers', 'Where can I volunteer with dogs and cats']
  }, {
    id: 2,
    name: 'Food Bank Assistance',
    description: 'Combat hunger in local communities',
    image: 'https://images.unsplash.com/photo-1593113630400-ea4288922497',
    isMatching: false,
    intentPhrases: ['Want to help feed the homeless', 'Food bank volunteer opportunities', 'How to donate food to those in need']
  }, {
    id: 3,
    name: 'Literacy Programs',
    description: 'Promote reading and education',
    image: 'https://images.unsplash.com/photo-1503676260728-1c00da094a0b',
    isMatching: false,
    intentPhrases: ['How to help kids learn to read', 'Volunteer as a reading tutor', 'Literacy volunteer opportunities']
  }, {
    id: 4,
    name: 'Beach Cleanup',
    description: 'Protect oceans and marine life',
    image: 'https://images.unsplash.com/photo-1618477461853-cf6ed80faba5',
    isMatching: false,
    intentPhrases: ['Ocean pollution is terrible', 'Want to help clean up beaches', 'Environmental volunteer opportunities']
  }, {
    id: 5,
    name: 'Hospital Volunteering',
    description: 'Support patients and healthcare workers',
    image: 'https://images.unsplash.com/photo-1579684385127-1ef15d508118',
    isMatching: false,
    intentPhrases: ['How to volunteer at hospitals', 'Want to help patients', 'Healthcare volunteer opportunities']
  }]);
  const [matchedPost, setMatchedPost] = useState(null);
  const [matchedProduct, setMatchedProduct] = useState(null);
  const [showMatchModal, setShowMatchModal] = useState(false);
  // Simulate real-time post stream
  useEffect(() => {
    const interval = setInterval(() => {
      const newPost = generateMockPosts(1)[0];
      setPosts(prevPosts => [newPost, ...prevPosts.slice(0, 19)]);
      // Simulate random matches
      if (Math.random() < 0.3) {
        const randomProductIndex = Math.floor(Math.random() * products.length);
        const product = products[randomProductIndex];
        // Update product matching state
        const updatedProducts = [...products];
        updatedProducts[randomProductIndex] = {
          ...product,
          isMatching: true
        };
        setProducts(updatedProducts);
        // Set match data
        setMatchedPost(newPost);
        setMatchedProduct(product);
        setShowMatchModal(true);
        // Show toast notification
        toast.success(`✅ Matched @${newPost.username} → ${product.name}`);
        // Reset product matching state after animation
        setTimeout(() => {
          const resetProducts = [...updatedProducts];
          resetProducts[randomProductIndex] = {
            ...product,
            isMatching: false
          };
          setProducts(resetProducts);
        }, 5000);
      }
    }, 5000);
    return () => clearInterval(interval);
  }, [products]);
  const handleApproveReply = () => {
    toast.success(`✅ Posted reply to @${matchedPost.username}`);
    setShowMatchModal(false);
  };
  return <div className="flex flex-col md:flex-row gap-4 h-[calc(100vh-120px)]" data-id="element-183">
      {/* Left panel - Social Stream (70%) */}
      <div className="w-full md:w-[70%] bg-gray-800 rounded-lg overflow-hidden" data-id="element-184">
        <SocialStream posts={posts} matchedPost={matchedPost} data-id="element-185" />
      </div>
      {/* Right panel - Products (30%) */}
      <div className="w-full md:w-[30%] bg-gray-800 rounded-lg overflow-hidden" data-id="element-186">
        <ProductsPanel products={products} data-id="element-187" />
      </div>
      {/* Match Modal */}
      {showMatchModal && matchedPost && matchedProduct && <MatchModal post={matchedPost} product={matchedProduct} onClose={() => setShowMatchModal(false)} onApprove={handleApproveReply} data-id="element-188" />}
    </div>;
};
export default LiveFeed;